import styled from 'styled-components'

export const ContainerDefault = styled.section`
    height: 89vh;
    overflow-y: hidden;
    box-sizing: border-box;
    padding: 5px;

    div.ContainerDefault__content {
        width: 100%;
        height: 98.5%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 15px;
        border: thin solid var(--border-color);

        div.ContainerDefault__content__header {
            width: 100%;
            height: 40px;
            display: flex;
            gap: 15px;
        }
        div.ContainerDefault__content__children {
            width: 100%;
            height: calc(100% - 40px);
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
`
